var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTitipBayar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DCEFD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_1044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.625 20C24.625 22.418 22.668 24.375 20.25 24.375C17.832 24.375 15.875 22.418 15.875 20C15.875 17.582 17.832 15.625 20.25 15.625C22.668 15.625 24.625 17.582 24.625 20ZM19.625 18.75V21.25H19.3125C18.9688 21.25 18.6875 21.5312 18.6875 21.875C18.6875 22.2188 18.9688 22.5 19.3125 22.5H21.1875C21.5312 22.5 21.8125 22.2188 21.8125 21.875C21.8125 21.5312 21.5312 21.25 21.1875 21.25H20.875V18.125C20.875 17.7812 20.5938 17.5 20.25 17.5H19.625C19.2812 17.5 19 17.7812 19 18.125C19 18.4688 19.2812 18.75 19.625 18.75ZM9 15C9 13.6191 10.1191 12.5 11.5 12.5H29C30.3789 12.5 31.5 13.6191 31.5 15V25C31.5 26.3789 30.3789 27.5 29 27.5H11.5C10.1191 27.5 9 26.3789 9 25V15ZM10.875 16.875V23.125C12.2559 23.125 13.375 24.2461 13.375 25.625H27.125C27.125 24.2461 28.2461 23.125 29.625 23.125V16.875C28.2461 16.875 27.125 15.7539 27.125 14.375H13.375C13.375 15.7539 12.2559 16.875 10.875 16.875Z",
    fill: "#218907"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_1044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 20,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTitipBayar);
export default __webpack_public_path__ + "static/media/icon-titip-bayar.41d0a1612181b7a7abeaabf8e68eb2e1.svg";
export { ForwardRef as ReactComponent };